import { render, staticRenderFns } from "./BannerEdit.vue?vue&type=template&id=0f5fdcd8&"
import script from "./BannerEdit.vue?vue&type=script&lang=js&"
export * from "./BannerEdit.vue?vue&type=script&lang=js&"
import style0 from "./BannerEdit.vue?vue&type=style&index=0&id=0f5fdcd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports